import React from 'react';
import { useTranslation } from 'react-i18next';

const MemoryView: React.FC = () => {
  const { t } = useTranslation('webflash');

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        {t('debug.memory')}
      </h3>
      <div className="space-y-3">
        <div className="flex gap-2">
          <input
            type="text"
            placeholder={t('readback.address')}
            className="flex-1 border border-gray-300 dark:border-gray-600 rounded px-2 py-1 text-sm font-mono bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            disabled
          />
          <input
            type="text"
            placeholder={t('readback.length')}
            className="w-24 border border-gray-300 dark:border-gray-600 rounded px-2 py-1 text-sm font-mono bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            disabled
          />
        </div>
        <pre className="bg-gray-50 dark:bg-gray-900 rounded p-3 text-xs font-mono text-gray-400 overflow-auto max-h-48">
          No data
        </pre>
      </div>
    </div>
  );
};

export default MemoryView;
